require.config({
	'baseUrl': 'js',
	'paths': {
		'jquery': '//code.jquery.com/jquery-2.1.1.min',
		'jquery-private': 'app/jquery-private',
		'jquery.form': 'plugins/jquery.form',
		'jquery.cookie': '//cdnjs.cloudflare.com/ajax/libs/jquery-cookie/1.4.1/jquery.cookie'
	},
	'shim': {
		'jquery.form': {
			deps: ['jquery-private'],
			exports: 'jQuery.fn.form'
	    },
		'jquery.cookie': {
			deps: ['jquery-private'],
			exports: 'jQuery.fn.cookie'
	    }
	}
});

// Fading header carousel
require(['jquery-private', 'app/slider'], function($, Slideshow) {

	var el = $('.home #site-header'),
		image_root = theme_url+'/lib/img/bg/main-carousel/',
		image_array = [
			image_root+'fibre-optic.jpg', 
			image_root+'ports.jpg', 
			image_root+'cables.jpg'
		],
		header_carousel;

	if ( el.length ) {
		if ( $(window).width() > 767 ) {
			header_carousel = new Slideshow({el: el, images: image_array});
			header_carousel.init();
		} else {
			if ( header_carousel ) header_carousel.destroy();
		}
	}
});

// Cookie policy notification
require(['app/cookie-policy']);

// Contact Form 7 plugin
require(['plugins/contactform7']);

// Check for placeholder support
require(['jquery-private'], function($) {

	// Show form labels if placeholders aren't supported
	if (!Modernizr.input.placeholder) {
		$('label', '.form-field').removeClass('hide');
	}
});

// Collapsing navigation
require(['jquery-private', 'app/navigation'], function($, CollapsingNav) {

	// Instantiation
	var menuPrimary = new CollapsingNav('#menu-primary-holder', 768);
	menuPrimary.init();

	// Handle viewport resizing
	var resize;
	$(window).resize(function() {
		clearTimeout(resize);
		resize = setTimeout(function() {
		
			menuPrimary.init();

		}, 250);
	});

});
define("main", function(){});

